import { required, numeric, helpers } from "vuelidate/lib/validators";
import Vue from "vue";

export function isMatchIdPattern(v) {
  return /^[A-Z0-9]{6,12}?$/.test(v);
}

/**
 * 이체금액 : 금액은 1이상 입력하셔야 합니다.
 * @param {*} val
 * @param {*} paramObj
 */
export function amtCheck(val, paramObj) {
  let amt = 0;
  let amt01 = 0;
  let amt02 = 0;
  if (this._.has(paramObj, "drwotAmt01") && this._.has(paramObj, "drwotAmt02")) {
    amt01 = paramObj.drwotAmt01;
    amt02 = paramObj.drwotAmt02;
  } else if (this._.has(paramObj, "mnrcvAmt01") && this._.has(paramObj, "mnrcvAmt02")) {
    amt01 = paramObj.mnrcvAmt01;
    amt02 = paramObj.mnrcvAmt02;
  } else if (this._.has(paramObj, "outwdRmtancAmt01") && this._.has(paramObj, "outwdRmtancAmt02")) {
    amt01 = paramObj.outwdRmtancAmt01;
    amt02 = paramObj.outwdRmtancAmt02;
  }
  let tmp = this._.defaultTo(amt01, 0) + "." + amt02;

  amt = Math.floor(tmp.replace(/,/gi, "")).toFixed(2);
  return amt >= 1;
}

/**
 * 이체금액 : 필수 항목입니다.
 * @param amt1 정수
 * @param amt2 소수점
 */
export const amtRequired = (amt1, amt2) => () => {
  if (amt1 === undefined || amt2 == undefined) return true;
  return required(amt1) && required(amt2);
};

/**
 * 이체금액 : 숫자 형식이 아닙니다.
 * @param amt1 정수
 * @param amt2 소수점
 */
export const amtNumeric = (amt1, amt2) => () => {
  if (amt1 === undefined || amt2 == undefined) return true;
  return numeric(amt1.replace(/,/gi, "")) && numeric(amt2);
};

/**
 *  valType=amt 최소값(1) 체크
 * @param {*} val
 */
export function amtMinValue(val) {
  let tmpVal = "" + val;
  let validNum = Number(tmpVal.replace(/,/gi, ""));
  return validNum >= 1;
}

/**
 * minValue
 * @param {*} val
 */
export const minValue = min => value => {
  let tmpVal = "" + value;
  let validNum = Number(tmpVal.replace(/,/gi, ""));

  return validNum >= min;
};

/**
 *  maxValue
 * @param {*} val
 */
export const maxValue = max => value => {
  let tmpVal = "" + value;
  let validNum = Number(tmpVal.replace(/,/gi, ""));
  return validNum <= max;
};

/**
 * 통화코드별 소숫점 이하 금액 체크
 * @param Object {cncycd : 통화코드, amt: 소수점금액}
 */
export const cncycdDecpCheck = cncycd => value => {
  if (cncycd === undefined) return true;
  let res = true;
  switch (cncycd) {
    case Vue.prototype.$config.CNCYCD_ITL:
    case Vue.prototype.$config.CNCYCD_ESP:
    case Vue.prototype.$config.CNCYCD_JPY:
    case Vue.prototype.$config.CNCYCD_KRW:
    case Vue.prototype.$config.CNCYCD_VND:
      if (value.indexOf(".") > -1) res = false;
      break;
  }
  return res;
};

/**
 * 오클랜드 해외송금일 경우 출금계좌의 허용 통화코드 체크
 * NZD -> USD, AUD, EUR, JPY
 * USD -> USD, NZD
 * AUD -> AUD, NZD
 * EUR -> EUR, NZD
 * JPY -> JPY, NZD
 * KRW -> KRW, NZD
 * @param {*} params
 */
export const ovsesCheck = params => () => {
  if (params.baseCncycd === undefined) return false;
  let res = true;
  switch (params.baseCncycd) {
    case Vue.prototype.$config.CNCYCD_USD:
      if (!(params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_USD || params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_NZD)) {
        res = false;
      }
      break;
    case Vue.prototype.$config.CNCYCD_AUD:
      if (!(params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_AUD || params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_NZD)) {
        res = false;
      }
      break;
    case Vue.prototype.$config.CNCYCD_EUR:
      if (!(params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_EUR || params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_NZD)) {
        res = false;
      }
      break;
    case Vue.prototype.$config.CNCYCD_JPY:
      if (!(params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_JPY || params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_NZD)) {
        res = false;
      }
      break;
    case Vue.prototype.$config.CNCYCD_KRW:
      if (!(params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_KRW || params.drwotAcnoCycncd == Vue.prototype.$config.CNCYCD_NZD)) {
        res = false;
      }
      break;
  }
  return res;
};

/**
 * 입력한 문자 바이트 길이 체크
 * @param {*} params 계산할 문자열
 */
export const lengthByteCheck = params => () => {
  if (params.text === undefined) return false;
  let b;

  b = Vue.prototype.$getByteLength(params.text);
  return !(b > params.maxLength);
};

/**
 * 영문, 숫자, 띄어쓰기
 */
export const alphaNum = helpers.regex("alphaNum", /^[0-9a-zA-Z%\s]*$/);

/**
 * 영문, 숫자
 */
export const alphaNumOnly = helpers.regex("alphaNumOnly", /^[0-9a-zA-Z]*$/);

/**
 * 숫자, 특수문자 , .
 */
export const numericComma = helpers.regex("numericComma", /^((\d+)|(\d{1,3}(,\d{1,3})+)|(\d{1,3}(,\d{3})(,\d{3})+))(.\d{1,2})?$/);

/**
 * 영문, 숫자, 띄어쓰기, 특수문자 . - & ( ) / %
 */
export const engCase1 = helpers.regex("engCase1", /^[0-9a-zA-Z.&\-()/%\s]*$/);

/**
 * 영문, 숫자, 띄어쓰기, 특수문자   -
 */
export const engCase2 = helpers.regex("engCase2", /^[0-9a-zA-Z\-\s]*$/);

/**
 * 영문, 숫자, 띄어쓰기, 특수문자 . - & ( ) /
 */
export const engCase3 = helpers.regex("engCase3", /^[0-9a-zA-Z.&\-()/\s]*$/);

/**
 * 영문, 숫자, 띄어쓰기, 특수문자 . -   ( ) /   , : +
 */
export const engCase4 = helpers.regex("engCase4", /^[0-9a-zA-Z.\-()/,:+\s]*$/);

/**
 * 영문, 숫자, 띄어쓰기, 특수문자 . - & ( ) /   , :
 */
export const engCase5 = helpers.regex("engCase5", /^[0-9a-zA-Z.\-&()/,:\s]*$/);

/**
 * 영문, 숫자, 띄어쓰기, 특수문자 . - & ( ) /   , : + ? ' { }
 */
export const engCase6 = helpers.regex("engCase6", /^[0-9a-zA-Z.\-&()/,:+?'{}\s]*$/);

/**
 * 영문, 숫자, 띄어쓰기, 특수문자 , - ( )
 */
export const engCase7 = helpers.regex("engCase7", /(^[0-9a-zA-Z])[0-9a-zA-Z/,\-()\s]*$/);

/**
 * 영문, 숫자, 띄어쓰기, (키보드에 있는)특수문자
 */
export const engCase8 = helpers.regex("engCase8", /^[0-9a-zA-Z`~!@#$%^&*()\-_=+|/,<.>?;:'"`{[\]}\s]*$/);

/**
 * 외국어, 숫자, 특수문자 . - & ( ) / %
 */
export const localeCase1 = value => {
  const regex = new RegExp(/[\][`~!@#$^*_|+=?;:'",<>{}\\]/g);
  return !regex.test(value);
};

/**
 * 외국어, 숫자, 띄어쓰기, 특수문자   -
 */
export const localeCase2 = value => {
  const regex = new RegExp(/[\][`~!@#$%^&*()_|+=?;:'",.<>{}\\/]/g);
  return !regex.test(value);
};

/**
 * 외국어, 숫자, 띄어쓰기, 특수문자 . - & ( ) /
 */
export const localeCase3 = value => {
  const regex = new RegExp(/[\][`~!@#$%^*_|+=?;:'",<>{}\\]/g);
  return !regex.test(value);
};

/**
 * 외국어, 숫자, 띄어쓰기, 특수문자 . -   ( ) /   , : +
 */
export const localeCase4 = value => {
  const regex = new RegExp(/[\][`~!@#$%^&*_|=?;'"<>{}\\]/g);
  return !regex.test(value);
};

/**
 * 외국어, 숫자
 */
export const localeNum = value => {
  const regex = new RegExp(/[\][`~!@#$%^&*_|=?:;'".,+\-()/<>{}\\]/g);
  return !regex.test(value);
};

/**
 * 외국어, 숫자, 특수문자 . - & ( ) / %
 */
export const alphaLocaleOnly1 = value => {
  const regex = new RegExp(/[\][ㄱ-ㅎ가-힣ㅏ-ㅣ`~!@#$^*_|+=?;:'",<>{}\\]/g);
  return !regex.test(value);
};

/**
 * 외국어, 숫자
 */
export const alphaLocaleOnly2 = value => {
  const regex = new RegExp(/[\][ㄱ-ㅎ가-힣ㅏ-ㅣ`~!@#$%^&*_|=?:;'".,+\-()/<>{}\\]/g);
  return !regex.test(value);
};

/**
 * 영문, 숫자, 띄어쓰기, 특수문자 - /
 */
export const alphaLocaleOnly3 = helpers.regex("engCase5", /^[0-9a-zA-Z\-/\s]*$/);